export default __webpack_public_path__ + "static/media/Artist.337923f4.png";